import { priorityConfig } from '@/constants/repair'
import { useUI } from '@/hooks/useUI'
import { AlertTriangle } from 'lucide-react'

const fallbackConfig = { color: 'text-muted-foreground', bgColor: 'bg-muted/15' }

export function PriorityBadge({ priority }: { priority: string }) {
  const { repairPriorities, getEnumLabel } = useUI()
  const config = priorityConfig[priority] ?? fallbackConfig
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-medium ${config.bgColor} ${config.color}`}
    >
      {priority === 'Critical' && <AlertTriangle className="size-2.5" />}
      {getEnumLabel(repairPriorities, priority, priority)}
    </span>
  )
}
